var $7bb36225cfd70b28$exports = {};
let $7bb36225cfd70b28$var$countrySelected = "";
//7days
let $7bb36225cfd70b28$var$expireTime = new Date(new Date().getTime() + 604800000);
function $7bb36225cfd70b28$var$validateFormModal() {
    let x = $("#country").val();
    $7bb36225cfd70b28$var$countrySelected = $("#country").find(":selected").attr("data-country");
    console.log($7bb36225cfd70b28$var$countrySelected);
    if (x == "") {
        $("#country").css("border-color", "#f45a5d");
        return false;
    } else if (x == "allowed") {
        Cookies.set("countrySelected", $7bb36225cfd70b28$var$countrySelected, {
            expires: $7bb36225cfd70b28$var$expireTime
        });
        // $(".step-one").hide();
        // $(".step-two").show();
        $("#next-btn-ghost").trigger("click");
        // ScrollTrigger.refresh();
        //stepTwo.showModal(); //show everyone except restricted
        //console.log(Cookies.get('countrySelected'));
        if ($7bb36225cfd70b28$var$countrySelected == "ksa") stepTwo.showModal();
        else if ($7bb36225cfd70b28$var$countrySelected == "others") stepTwoB.showModal();
    // $()
    } else {
        //   $(".step-one").hide();
        //   $(".restricted").show();
        $("#next-btn-ghost").trigger("click");
        // ScrollTrigger.refresh();
        restricted.showModal();
    }
}
document.addEventListener("DOMContentLoaded", function() {
    $("#agree-btn-yes").on("click", function() {
        //$('.modal-disclaimer').remove(); // close modal
        //console.log('agree-btn-yes clicked')
        $("#agree-btn-yes-ghost").trigger("click");
        // ScrollTrigger.refresh();
        // Set this cookie
        Cookies.set("notice", "shown", {
            expires: $7bb36225cfd70b28$var$expireTime
        });
        if (Cookies.get("countrySelected") == "others") //$(".forksa").css('display','none');
        $(".forksa").remove();
        else //$(".forothers").css('display','none');
        $(".forothers").remove();
    });
    //second disclaimer
    $("#agree-btn-yesTwo").on("click", function() {
        //$('.modal-disclaimer').remove(); // close modal
        //console.log('agree-btn-yestwo clicked')
        $("#agree-btn-yes-ghostTwo").trigger("click");
        // ScrollTrigger.refresh();
        // Set this cookie
        Cookies.set("notice", "shown", {
            expires: $7bb36225cfd70b28$var$expireTime
        });
        if (Cookies.get("countrySelected") == "others") //$(".forksa").css('display','none');
        $(".forksa").remove();
        else //$(".forothers").css('display','none');
        $(".forothers").remove();
    });
    $("#agree-not-btn").on("click", function() {
        //   $(".step-two").hide();
        //   $(".restricted").show();
        $("#agree-not-btn-ghost").trigger("click");
        // ScrollTrigger.refresh();
        restricted.showModal();
    });
    $("#agree-not-btnTwo").on("click", function() {
        //   $(".step-two").hide();
        //   $(".restricted").show();
        $("#agree-not-btn-ghostTwo").trigger("click");
        // ScrollTrigger.refresh();
        //restrictedTwo.showModal();
        restricted.showModal();
    });
});
$("#next-btn").on("click", function() {
    $7bb36225cfd70b28$var$validateFormModal();
//console.log("click next on modal")
});
$("#nomore.forothers:lang(en)").on("click", function() {
    //console.log(countrySelected);
    if (Cookies.get("countrySelected") == "others") //$(".forksa").css('display','none');
    //$(".forksa").remove();
    //console.log("hide for ksa, ksa not selected");
    stepTwoB.showModal(); //second disclaimer
    else {
        //$(".forothers").css('display','none');
        //$(".forothers").remove();
        //console.log("hide for others, ksa is selected");
        const fileUrl1 = "/documents/Prospectus_ADES_Holding_Co_EN.pdf"; // Replace with your desired file URL
        const fileName = "Prospectus_ADES_Holding_Co_EN.pdf"; // Replace with your desired file name
        $7bb36225cfd70b28$var$downloadFile(fileUrl1, fileName);
    }
});
$("#nomore.forothers:lang(ar)").on("click", function() {
    //console.log(countrySelected);
    if (Cookies.get("countrySelected") == "others") //$(".forksa").css('display','none');
    //$(".forksa").remove();
    //console.log("hide for ksa, ksa not selected");
    stepTwoB.showModal(); //second disclaimer
    else {
        //$(".forothers").css('display','none');
        //$(".forothers").remove();
        //console.log("hide for others, ksa is selected");
        const fileUrl1 = "/documents/Prospectus_ADES_Holding_Co_AR.pdf"; // Replace with your desired file URL
        const fileName = "Prospectus_ADES_Holding_Co_AR.pdf"; // Replace with your desired file name
        $7bb36225cfd70b28$var$downloadFile(fileUrl1, fileName);
    }
});
//dont forget to update this to support AR PDF
$("#nomore.agree-download:lang(en)").on("click", function() {
    const fileUrl = "/documents/Prospectus_ADES_Holding_Co_EN.pdf"; // Replace with your desired file URL
    const fileName = "Prospectus_ADES_Holding_Co_EN.pdf"; // Replace with your desired file name
    $7bb36225cfd70b28$var$downloadFile(fileUrl, fileName);
    $("#agree-btn-yes-ghostTwo").trigger("click");
});
$("#nomore.agree-download:lang(ar)").on("click", function() {
    const fileUrl = "/documents/Prospectus_ADES_Holding_Co_AR.pdf"; // Replace with your desired file URL
    const fileName = "Prospectus_ADES_Holding_Co_AR.pdf"; // Replace with your desired file name
    $7bb36225cfd70b28$var$downloadFile(fileUrl, fileName);
    $("#agree-btn-yes-ghostTwo").trigger("click");
});
function $7bb36225cfd70b28$var$downloadFile(url, fileName) {
    // Create a link element
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName; // File name
    // Append the link to the DOM and click it programmatically
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
} // document.getElementById("downloadButton").addEventListener("click", function() {
 //     const fileUrl = "https://www.example.com/example.txt"; // Replace with your desired file URL
 //     const fileName = "example.txt"; // Replace with your desired file name
 //     downloadFile(fileUrl, fileName);
 // });


//# sourceMappingURL=ar.073de234.js.map
